<app-perfil-shell [showGreeting]="false" [showSecurityBanner]="false" [skipFooterCms]="true" [sectionViewport]="true">
  <div class="perfil-section-page">
    <div class="perfil-section-page__chrome">
      <app-perfil-steps-strip activa="sobre-negocio"></app-perfil-steps-strip>
    </div>

    <div class="perfil-section-page__scroll" #sectionScroll (scroll)="hideNombreNegocioHint()">
      <div class="perfil-section-page__scroll-inner">
        <form class="perfil-section-page__panel perfil-section-page__panel--flat" [formGroup]="form"
          (ngSubmit)="onCta()">
          @if (currentStepId === 'ubicacion') {
          <div class="perfil-section-page__grid">
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('nombreNegocio')">
              <div class="perfil-field__label-with-hint">
                <label class="perfil-field__label" for="nombreNegocio">{{
                  copy.sobreNegocio.campos.nombreNegocio
                  }}</label>
                <button type="button" class="perfil-field__hint" [attr.aria-label]="copy.sobreNegocio.nombreNegocioHint"
                  [attr.aria-describedby]="'tooltip-nombre-negocio'" [attr.aria-expanded]="nombreNegocioHintOpen"
                  (mouseenter)="showNombreNegocioHint($event)" (mouseleave)="hideNombreNegocioHint()"
                  (focus)="showNombreNegocioHint($event)" (blur)="hideNombreNegocioHint()">
                  <span class="material-icons perfil-field__hint-icon" aria-hidden="true">help_outline</span>
                  <span id="tooltip-nombre-negocio" class="perfil-field__tooltip"
                    [class.perfil-field__tooltip--open]="nombreNegocioHintOpen"
                    [style.top]="nombreNegocioHintStyle['top']" [style.left]="nombreNegocioHintStyle['left']"
                    role="tooltip">
                    {{ copy.sobreNegocio.nombreNegocioHint }}
                  </span>
                </button>
              </div>
              <input id="nombreNegocio" class="perfil-field__control" type="text" formControlName="nombreNegocio"
                [placeholder]="copy.sobreNegocio.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('nombreNegocio')" />
              @if (isInvalid('nombreNegocio')) {
              <p class="perfil-field__error">{{ errorMessage('nombreNegocio') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('departamento')">
              <label class="perfil-field__label" for="departamento">{{
                copy.sobreNegocio.campos.departamento
                }}</label>
              <select id="departamento" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona departamento"
                formControlName="departamento" (change)="onDepartamentoChange($event)"
                [class.perfil-field__control--invalid]="isInvalid('departamento')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreNegocio.placeholderSelect }}</option>
                @for (opt of departamentos; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('departamento')) {
              <p class="perfil-field__error">{{ errorMessage('departamento') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('ciudad')">
              <label class="perfil-field__label" for="ciudad">{{
                copy.sobreNegocio.campos.ciudad
                }}</label>
              <select id="ciudad" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona ciudad"
                formControlName="ciudad" (change)="onCiudadChange()"
                [class.perfil-field__control--invalid]="isInvalid('ciudad')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreNegocio.placeholderSelect }}</option>
                @for (opt of ciudades; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('ciudad')) {
              <p class="perfil-field__error">{{ errorMessage('ciudad') }}</p>
              }
            </div>

            @if (muestraLocalidad) {
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('localidad')">
              <label class="perfil-field__label" for="localidad">{{
                copy.sobreNegocio.campos.localidad
                }}</label>
              <select id="localidad" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona localidad"
                formControlName="localidad" (change)="onLocalidadChange()"
                [class.perfil-field__control--invalid]="isInvalid('localidad')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreNegocio.placeholderSelect }}</option>
                @for (opt of localidades; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('localidad')) {
              <p class="perfil-field__error">{{ errorMessage('localidad') }}</p>
              }
            </div>
            }

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('barrio')">
              <label class="perfil-field__label" for="barrio">{{
                copy.sobreNegocio.campos.barrio
                }}</label>
              <input id="barrio" class="perfil-field__control" type="text" formControlName="barrio"
                [placeholder]="copy.sobreNegocio.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('barrio')" />
              @if (isInvalid('barrio')) {
              <p class="perfil-field__error">{{ errorMessage('barrio') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('direccion')">
              <label class="perfil-field__label" for="direccion">{{
                copy.sobreNegocio.campos.direccion
                }}</label>
              <input id="direccion" class="perfil-field__control" type="text" formControlName="direccion"
                [placeholder]="copy.sobreNegocio.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('direccion')" />
              @if (isInvalid('direccion')) {
              <p class="perfil-field__error">{{ errorMessage('direccion') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('tipoVivienda')">
              <label class="perfil-field__label" for="tipoVivienda">{{
                copy.sobreNegocio.campos.tipoVivienda
                }}</label>
              <select id="tipoVivienda" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona tipo de vivienda"
                formControlName="tipoVivienda" (change)="onTipoViviendaChange()"
                [class.perfil-field__control--invalid]="isInvalid('tipoVivienda')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreNegocio.placeholderSelect }}</option>
                @for (opt of tiposVivienda; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('tipoVivienda')) {
              <p class="perfil-field__error">{{ errorMessage('tipoVivienda') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('tieneRut')">
              <span class="perfil-field__label" id="lbl-tiene-rut">{{
                copy.sobreNegocio.campos.tieneRut
                }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-tiene-rut">
                <label class="perfil-radio">
                  <input type="radio" formControlName="tieneRut" value="si" />
                  <span>{{ copy.sobreNegocio.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="tieneRut" value="no" />
                  <span>{{ copy.sobreNegocio.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('tieneRut')) {
              <p class="perfil-field__error">{{ errorMessage('tieneRut') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('tieneCamaraComercio')">
              <span class="perfil-field__label" id="lbl-tiene-camara">{{
                copy.sobreNegocio.campos.tieneCamaraComercio
                }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-tiene-camara">
                <label class="perfil-radio">
                  <input type="radio" formControlName="tieneCamaraComercio" value="si" />
                  <span>{{ copy.sobreNegocio.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="tieneCamaraComercio" value="no" />
                  <span>{{ copy.sobreNegocio.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('tieneCamaraComercio')) {
              <p class="perfil-field__error">{{ errorMessage('tieneCamaraComercio') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--hidden]="!muestraFechaCamara"
              [class.perfil-field--invalid]="isInvalid('fechaRegistroCamara')">
              <div class="perfil-field__label-with-hint">
                <label class="perfil-field__label" for="fechaRegistroCamara">{{
                  copy.sobreNegocio.campos.fechaRegistroCamara
                  }}</label>
                @if (mensajeFechaRegistro) {
                <button type="button" class="perfil-field__hint" [attr.aria-label]="mensajeFechaRegistro"
                  [attr.aria-describedby]="'tooltip-fecha-camara'" [attr.aria-expanded]="fechaCamaraHintOpen"
                  (mouseenter)="showFechaCamaraHint($event)" (mouseleave)="hideNombreNegocioHint()"
                  (focus)="showFechaCamaraHint($event)" (blur)="hideNombreNegocioHint()">
                  <span class="material-icons perfil-field__hint-icon" aria-hidden="true">help_outline</span>
                  <span id="tooltip-fecha-camara" class="perfil-field__tooltip"
                    [class.perfil-field__tooltip--open]="fechaCamaraHintOpen"
                    [style.top]="fechaCamaraHintStyle['top']" [style.left]="fechaCamaraHintStyle['left']"
                    role="tooltip">
                    {{ mensajeFechaRegistro }}
                  </span>
                </button>
                }
              </div>
              <input id="fechaRegistroCamara" class="perfil-field__control" type="date"
                formControlName="fechaRegistroCamara" [attr.placeholder]="copy.sobreNegocio.placeholderFecha"
                [attr.max]="fechaActual" min="1900-01-01" [attr.title]="mensajeFechaRegistro"
                [class.perfil-field__control--invalid]="isInvalid('fechaRegistroCamara')" />
              @if (isInvalid('fechaRegistroCamara')) {
              <p class="perfil-field__error">{{ errorMessage('fechaRegistroCamara') }}</p>
              }
            </div>
          </div>
          }

          @if (currentStepId === 'fotos') {
          <div class="perfil-fotos">
            <div class="perfil-fotos__intro">
              <h2 class="perfil-fotos__title perfil-field--required">
                <span class="perfil-field__label">{{ copy.sobreNegocio.fotosHeading }}</span>
              </h2>
              <p class="perfil-fotos__hint">{{ copy.sobreNegocio.fotosHint }}</p>
            </div>

            <div class="perfil-fotos__list">
              @for (doc of fotoDocs; track doc.valueKey; let i = $index) {
              <div class="perfil-fotos__row" [class.perfil-fotos__row--loaded]="hasFotoLoaded(i)"
                [class.perfil-fotos__row--invalid]="isInvalid(doc.valueKey) && !hasFoto(i)"
                [class.perfil-fotos__row--rejected]="isFotoRechazada(i)"
                [class.perfil-fotos__row--approved]="isFotoAprobadaUi(i)">
                <p class="perfil-fotos__label">{{ i + 1 }}. {{ labelDoc(doc) }}</p>

                <input #fotoInput class="perfil-cedula__input" type="file"
                  [accept]="acceptFor(doc)" [attr.aria-label]="doc.label"
                  (change)="onFotoSelected(i, $event)" />

                @if (!hasFotoLoaded(i)) {
                <button type="button" class="perfil-btn perfil-btn--upload perfil-fotos__upload-btn"
                  [attr.id]="'btn-perfil-foto-' + doc.valueKey" (click)="onFotoCargarClick(i)">
                  <span class="perfil-fotos__cta-desktop">{{ copy.sobreNegocio.fotosCta }}</span>
                  <span class="perfil-fotos__cta-mobile">{{
                    copy.sobreNegocio.fotosCtaMobile
                    }}</span>
                  <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                </button>
                } @else {
                <div class="perfil-fotos__file-card" role="status"
                  [class.perfil-fotos__file-card--rejected]="isFotoRechazada(i)"
                  [class.perfil-fotos__file-card--approved]="isFotoAprobadaUi(i)"
                  [ngbTooltip]="isFotoRechazada(i) ? (fotoObservacion(i) || copy.sobreNegocio.validaciones.documentosInconsistentes) : ''"
                  container="body">
                  <div class="perfil-fotos__file-icon-wrap">
                    <img class="perfil-fotos__file-icon" [src]="fotoArchivoIcon" alt="" width="24" height="24" />
                  </div>
                  <div class="perfil-fotos__file-meta">
                    <p class="perfil-fotos__file-name">{{ fotos[i].name }}</p>
                    <p class="perfil-fotos__file-status">
                      <span>{{ fotos[i].sizeLabel }}</span>
                      <span aria-hidden="true"> • </span>
                      <span>{{ fotoStatusLabel(i) }}</span>
                    </p>
                    @if (isFotoRechazada(i) && fotoObservacion(i)) {
                    <p class="perfil-fotos__file-obs">{{ fotoObservacion(i) }}</p>
                    }
                  </div>
                  @if (canRemoveFoto(i)) {
                  <button type="button" class="perfil-fotos__file-remove"
                    [attr.aria-label]="copy.sobreNegocio.fotosArchivoQuitar" (click)="removeFoto(i)">
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                  }
                </div>
                }

                @if (isInvalid(doc.valueKey) && !hasFoto(i)) {
                <p class="perfil-field__error perfil-fotos__error">{{
                  errorMessage(doc.valueKey)
                  }}</p>
                }
              </div>
              }
            </div>
          </div>
          }

          @if (currentStepId === 'info-adicional') {
          <div class="perfil-opcionales">
            <div class="perfil-opcionales__intro">
              <h2 class="perfil-opcionales__title">{{
                copy.sobreNegocio.docsOpcionalesHeading
                }}</h2>
              <p class="perfil-opcionales__hint">{{
                copy.sobreNegocio.docsOpcionalesHint
                }}</p>
            </div>

            <div class="perfil-opcionales__docs">
              @for (doc of documentosSeccion; track doc.valueKey) {
              <div class="perfil-opcionales__doc"
                [class.perfil-opcionales__doc--loaded]="hasDoc(doc.valueKey)"
                [class.perfil-opcionales__doc--multi]="doc.multiple">
                <div class="perfil-opcionales__doc-text">
                  <p class="perfil-opcionales__doc-title">{{ labelDoc(doc) }}</p>
                  @if (doc.descripcion) {
                  <p class="perfil-opcionales__doc-desc">{{ doc.descripcion }}</p>
                  }
                </div>

                <div class="perfil-opcionales__doc-slots"
                  [class.perfil-opcionales__doc-slots--multi]="isDocMultiple(doc)">
                  @if (isDocMultiple(doc)) {
                  <div class="perfil-opcionales__doc-multi-head">
                    <span class="perfil-opcionales__doc-multi-hint">{{ multiUploadHint(doc) }}</span>
                    <span class="perfil-opcionales__doc-multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                  </div>

                  @for (slot of filledSlots(doc); track slot.slotKey) {
                  <div class="perfil-fotos__file-card perfil-opcionales__file-card" role="status"
                    [class.perfil-fotos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                    [class.perfil-fotos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                    [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreNegocio.validaciones.documentosInconsistentes) : ''"
                    container="body">
                    <div class="perfil-fotos__file-icon-wrap">
                      <img class="perfil-fotos__file-icon" [src]="fotoArchivoIcon" alt="" width="24" height="24" />
                    </div>
                    <div class="perfil-fotos__file-meta">
                      <div class="perfil-fotos__file-top">
                        <p class="perfil-fotos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                        @if (canRemoveSlot(slot.slotKey)) {
                        <button type="button" class="perfil-fotos__file-remove"
                          [attr.aria-label]="copy.sobreNegocio.fotosArchivoQuitar"
                          (click)="removeDoc(slot.slotKey)">
                          <span class="material-icons" aria-hidden="true">close</span>
                        </button>
                        }
                      </div>
                      <p class="perfil-fotos__file-status">
                        <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                        <span aria-hidden="true"> • </span>
                        <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                      </p>
                      @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                      <p class="perfil-fotos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                      }
                    </div>
                  </div>
                  }

                  @if (nextEmptySlot(doc); as next) {
                  <div class="perfil-opcionales__doc-slot">
                    <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(next.slotKey, $event)" />
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-opcionales__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + next.slotKey"
                      (click)="onDocCargarClick(doc, next.slotKey, docInput)">
                      <span>{{ multiUploadCta(doc) }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                  </div>
                  }
                  } @else {
                  @for (slot of slotsFor(doc); track slot.slotKey) {
                  <div class="perfil-opcionales__doc-slot">
                    <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(slot.slotKey, $event)" />

                    @if (!hasSlotDoc(slot.slotKey)) {
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-opcionales__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + slot.slotKey"
                      (click)="onDocCargarClick(doc, slot.slotKey, docInput)">
                      <span>{{ copy.sobreNegocio.fotosCta }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                    } @else {
                    <div class="perfil-fotos__file-card perfil-opcionales__file-card" role="status"
                      [class.perfil-fotos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                      [class.perfil-fotos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                      [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreNegocio.validaciones.documentosInconsistentes) : ''"
                      container="body">
                      <div class="perfil-fotos__file-icon-wrap">
                        <img class="perfil-fotos__file-icon" [src]="fotoArchivoIcon" alt="" width="24" height="24" />
                      </div>
                      <div class="perfil-fotos__file-meta">
                        <div class="perfil-fotos__file-top">
                          <p class="perfil-fotos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                          @if (canRemoveSlot(slot.slotKey)) {
                          <button type="button" class="perfil-fotos__file-remove"
                            [attr.aria-label]="copy.sobreNegocio.fotosArchivoQuitar"
                            (click)="removeDoc(slot.slotKey, docInput)">
                            <span class="material-icons" aria-hidden="true">close</span>
                          </button>
                          }
                        </div>
                        <p class="perfil-fotos__file-status">
                          <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                          <span aria-hidden="true"> • </span>
                          <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                        </p>
                        @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                        <p class="perfil-fotos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                        }
                      </div>
                    </div>
                    }
                  </div>
                  }
                  }
                </div>
              </div>
              }
            </div>

            <div class="perfil-opcionales__redes">
              <div class="perfil-opcionales__redes-intro">
                <h3 class="perfil-opcionales__redes-title">{{
                  copy.sobreNegocio.redesHeading
                  }}</h3>
                <p class="perfil-opcionales__hint">{{ copy.sobreNegocio.redesHint }}</p>
              </div>

              <div class="perfil-opcionales__redes-list">
                @for (red of redesItems; track red.id) {
                <div class="perfil-opcionales__red">
                  <label class="perfil-opcionales__check-row">
                    <input class="perfil-opcionales__check-input" type="checkbox" [formControlName]="red.id" />
                    <span class="perfil-opcionales__check" aria-hidden="true">
                      <img class="perfil-opcionales__check-icon" [src]="checkIcon" alt="" width="12" height="9" />
                    </span>
                    <span class="perfil-opcionales__check-label">{{ red.label }}</span>
                  </label>
                  @if (isRedChecked(red.id)) {
                  <div class="perfil-opcionales__url-wrap" [class.perfil-field--invalid]="isInvalid(red.id + 'Url')">
                    <input class="perfil-field__control perfil-opcionales__url" type="url"
                      [formControlName]="red.id + 'Url'" [placeholder]="copy.sobreNegocio.placeholderUrl"
                      [attr.aria-label]="'URL de ' + red.label"
                      [class.perfil-field__control--invalid]="isInvalid(red.id + 'Url')" />
                    @if (isInvalid(red.id + 'Url')) {
                    <p class="perfil-field__error">{{
                      errorMessage(red.id + 'Url')
                      }}</p>
                    }
                  </div>
                  }
                </div>
                }
              </div>
            </div>
          </div>
          }
        </form>
      </div>
    </div>
  </div>

  <app-perfil-section-footer perfilSectionFooter variant="necesidad" seccionId="sobre-negocio" [showSaltar]="true"
    [ctaLabelOverride]="ctaLabel" [continuarDisabled]="continuarDisabled" (saltar)="onSaltar()"
    (continuar)="onCta()"></app-perfil-section-footer>
</app-perfil-shell>

<app-perfil-intro-modal [open]="introModalOpen" seccionId="sobre-negocio" (closed)="closeIntroModal()"
  (completarDatos)="onIntroCompletarDatos()"></app-perfil-intro-modal>

<app-perfil-documento-modal [open]="docModalOpen" [config]="docModalConfig" (closed)="closeDocModal()"
  (subir)="onSubirDesdeDocModal()"></app-perfil-documento-modal>

<app-perfil-salir-modal [open]="salirModalOpen" (closed)="closeSalirModal()"
  (guardar)="onSalirGuardar()"></app-perfil-salir-modal>